import http from '@/http';

export default class LogService {

	listarLogs(selecaoId, operacao) {
		return http.get(`log/listar/${selecaoId}/${operacao}`).then(res => res.data);
    }

	listarLogInscricao(identificador) {
		return http.get(`log/listar/inscricao/${identificador}`).then(res => res.data);
    }

	listarLogInscricaoOperacao(identificador, operacao) {
		return http.get(`log/listar/inscricao/${identificador}/${operacao}`).then(res => res.data);
    }

}
